import React from 'react';
import {
  Button,
  FormControl,
  TextField,
  CircularProgress,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import { currency } from '../../utils/utils';
import useHook from './useHook';
import styles from './styles.module.scss';

const ContenedorEnvios3 = () => {
  const {
    cp,
    reduxCp,
    loading,
    shippingsAndreani,
    fechaEntrega,
    handleChange,
    handleClean,
    open,
    toggleOpen,
  } = useHook();

  const hayResultados = Boolean(shippingsAndreani?.tarifaConIva);
  const hayCp = Boolean(cp && cp.length === 4);

  return (<>
    <div className={styles.box} style={{ maxWidth: "100%" }}>

      <button type="button" className={styles.header} onClick={toggleOpen} aria-expanded={open}>
        <span className={styles.headerTitulo}>
          <LocalShippingOutlinedIcon fontSize="small" />
          {hayCp ? `Envíos disponibles para ${reduxCp}` : 'Envíos y entrega'}
        </span>
        <ExpandMoreIcon className={`${styles.chevron} ${open ? styles.chevronOpen : ''}`} />
      </button>

      <div className={`${styles.collapse} ${open ? styles.collapseOpen : ''}`}>
        <div className={styles.collapseInner}>

          {(!cp || cp.length < 4)
            ?
            <div className={styles.container}>
              <p className={styles.titulo}>Ingresá tu código postal para calcular tu envío</p>
              <div style={{ maxWidth: "220px" }}>
                <FormControl fullWidth>
                  <TextField
                    required
                    fullWidth
                    id="cp"
                    label="Código postal"
                    variant="outlined"
                    type="tel"
                    value={cp}
                    autoComplete="current-email"
                    color="secondary"
                    onChange={(e) => handleChange(e.target.value)}
                    InputProps={{
                      style: {
                        borderRadius: "100px",
                        background: "#fff",
                      },
                    }}
                    inputProps={{ maxLength: 4 }}
                  />
                </FormControl>
              </div>
            </div>
            :
            <div className={styles.container}>
              {loading &&
                <CircularProgress size="30px" />
              }
              {!loading && shippingsAndreani?.tarifaConIva && <>
                <div className={styles.card}>
                  <div className={styles.cardFila}>
                    <span className={styles.cardNombre}>Envío a domicilio por Andreani</span>
                    <span className={styles.cardPrecio}>$ {currency(Math.ceil(shippingsAndreani.tarifaConIva))}</span>
                  </div>
                  <em><b>Fecha de entrega estimada</b>: {fechaEntrega.format('dddd D [de] MMMM')}.</em>
                </div>
              </>}
              {!loading && !hayResultados &&
                <div className={styles.item}>
                  <em>No pudimos cargar opciones de envío para este código postal.</em>
                </div>
              }

              <Button
                variant='text'
                color="secondary"
                className={styles.cambiarCp}
                onClick={handleClean}
              >Cambiar código postal</Button>
            </div>
          }

        </div>
      </div>
    </div>
  </>);
};

export default ContenedorEnvios3;
